import "../../assets/styles/components/modal-content/notification-content.scss";
import BackArrow from "../../assets/icons/back-arrow";

export default function NotificationContent({
  notification_info,
  setSelected = null,
}) {
  const handleClose = async () => {
    setSelected();
    document.querySelector("#close-bottom-panel-button").click();
  };

  return (
    <div className="notification-content">
      <small className="d-block text-end pt-3 mb-2">
        {notification_info.plannedPublishDate
          ? new Date(notification_info.plannedPublishDate).toLocaleDateString()
          : null}
      </small>
      {setSelected ? (
        <div style={{ marginLeft: "-0.5rem" }} className="d-flex mb-4">
          <BackArrow
            color="#20419a"
            size={25}
            className="me-3 mt-2"
            onClick={() => handleClose()}
          />
          <h1 className="notification-content__title my-0">
            {notification_info.title}
          </h1>
        </div>
      ) : (
        <h1 className="notification-content__title my-0">
          {notification_info.title}
        </h1>
      )}
      <p className="notification-content__description">
        {notification_info.text}
      </p>
    </div>
  );
}
